import { cloneDeep } from "lodash";
import { TFormBuilderItem, TFormBuilderItemData, TFormBuilderItemSettings, TFormBuilderItemType } from "../../model/item/formBuilderItem";
import { IFormBuilderForm } from "../../model/formBuilderForm";

type TPickItemTypeAndSettings<T> = T extends {
  type: TFormBuilderItemType;
  settings: TFormBuilderItemSettings;
}
  ? Pick<T, "type" | "settings">
  : never;

type TUpdatedItemSettings = TPickItemTypeAndSettings<TFormBuilderItemData>;

export interface IUpdateItemSettingsActionPayload {
  key: string;
  prevItemSettings: TUpdatedItemSettings;
  nextItemSettings: TUpdatedItemSettings;
}

export interface IUpdateItemSettingsAction {
  type: "UPDATE_ITEM_SETTINGS";
  payload: IUpdateItemSettingsActionPayload;
}

export function getUpdateItemSettingsInverseAction(
  action: IUpdateItemSettingsAction,
): IUpdateItemSettingsAction {
  return {
    type: "UPDATE_ITEM_SETTINGS",
    payload: {
      key: action.payload.key,
      prevItemSettings: action.payload.nextItemSettings,
      nextItemSettings: action.payload.prevItemSettings,
    },
  };
}

function applySettings(item: TFormBuilderItem, settings: TFormBuilderItemSettings): TFormBuilderItem {
  const updatedItem = cloneDeep(item);

  updatedItem.data.settings = {
    ...updatedItem.data.settings,
    ...settings,
  };
  
  return updatedItem;
}

export function applyUpdateItemSettingsChange(
  form: IFormBuilderForm,
  action: IUpdateItemSettingsAction,
): IFormBuilderForm {
  const { key, nextItemSettings } = action.payload;

  return {
    ...form,
    children: form.children.map(row => ({
      ...row,
      children: row.children.map(item => {
        if (item.key === key) {
          return applySettings(item, nextItemSettings.settings);
        } else {
          return item;
        }
      }),
    })),
  };
}
